import Loadable from "react-loadable";

const LazySynthese = Loadable({
  loader: () => import(/* webpackChunkName: 'comite-carrire-synthese' */ "./index"),
  loading: () => 'loading...'
});

export default LazySynthese;
